import { InMemoryCache } from '@apollo/client/core';
import {
    CheckoutState,
    SuccessfulPurchaseState,
} from '../feature/checkout/checkout.state';

export const cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                olsCheckoutState: {
                    read() {
                        return CheckoutState();
                    },
                },
                olsPurchasedGiftCard: {
                    read() {
                        return SuccessfulPurchaseState();
                    },
                },
                giftCardSettings: {
                    // read the value from the cache, always (regardless of ID)
                    read(cachedValue) {
                        return cachedValue;
                    },
                    // save the incoming data to the cache, regardless of the ID
                    merge(existing, incoming, { mergeObjects }) {
                        return mergeObjects(existing, incoming);
                    },
                },
                webAccountInfo: {
                    // read the value from the cache, always (regardless of ID)
                    read(cachedValue) {
                        return cachedValue;
                    },
                    // save the incoming data to the cache, regardless of the ID
                    merge(existing, incoming, { mergeObjects }) {
                        return mergeObjects(existing, incoming);
                    },
                },
            },
        },
    },
});
